import React from 'react';
import {notification} from 'antd';
import { Form, Spin, Input, Tooltip, Select, Row, Col, Button } from 'antd';
import history from '../../../modules/History';
import {getLuckyWheel, getLuckyWheelCoupon, updateLuckyWheelCoupon} from '../../../modules/Api';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class EditLuckyWheelCoupon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lucky_wheel_id: props.match.params.lucky_wheel_id,
            data: {},
            submitted: false,
        }

    }

    componentDidMount() {
        const id = this.props.match.params.id;
        getLuckyWheel(this.state.lucky_wheel_id, (res)=>{
            if(res.status==200){
                this.setState({lucky_wheel: res.data});
            }
            getLuckyWheelCoupon(this.state.lucky_wheel_id, id, (res)=>{
                if(res.status==200){
                    this.setState({data: res.data});
                }
            });
        });
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.submit(fieldsValue);
        })
    }

    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        updateLuckyWheelCoupon(this.state.lucky_wheel_id, this.state.data.id, values, (res) => {
            this.setState({submitted:false});

            if(res.status==200){
                notification.open({
                    message: `اطلاعات با موفقیت ویرایش شد!`,
                });
                history.item.push(`/lucky_wheels/coupons/${this.state.lucky_wheel_id}`);
            }
            else if(res.message != undefined){
                notification.open({
                    message: res.message,
                });
            }
        });
    }

    render() {
        if(this.state.data.id == undefined){
            return 'لطفا منتظر بمانید';
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;

        return (
            <div style={{direction: 'rtl'}}>
                    <Row>
                        <Col span={20} offset={1}>
                            عنوان گردونه: {this.state.lucky_wheel.title}<br/>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            عنوان کوپن: {this.state.data.coupon.title}<br/>
                        </Col>
                    </Row>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item
                            {...formItemLayout}
                            label="اولویت در گردونه"
                            colon={false}>
                            {getFieldDecorator("priority", {
                                initialValue: this.state.data.priority ? this.state.data.priority : '1',
                                rules: [{
                                    required: true, message:'لطفا عدد وارد کنید',
                                    pattern: new RegExp(
                                        /^[0-9]+$/i
                                    )
                                }]
                            })(
                                <Input/>
                            )}
                        </Form.Item>
                        <Form.Item>
                            <div className="btn-container">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={hasErrors(getFieldsError()) || this.state.submitted}
                                    >
                                    {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
            </div>
        );
    }
}

export default Form.create({ name: 'horizontal_login' })(EditLuckyWheelCoupon);



// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/Coupons/edit.js